import { DEFAULT_CURRENCY } from 'core/constants/currency.constants';
import { EOrderStatus } from 'core/model/enums/orders.enum';
import type { IOrderDetail, IOrderList } from 'core/model/interfaces/orders';
import { formatDate, formatLocaleDate, formatLocaleTime } from 'shared/utils/date.utils';
import type { IGetOrderDetailResponse, IGetOrdersListDTO } from './orders.dto';

export const mapOrderList = (response: IGetOrdersListDTO): IOrderList => ({
  pagination: response.pagination,
  orders: response.orders.map(order => ({
    orderId: order?.id || 0,
    clientCode: order?.customer?.externalId || '',
    businessName: order?.distributor?.name || '',
    orderNumber: order?.orderNumber || '',
    createdAt: order?.createdAt ? formatLocaleDate(order.createdAt, 'DD/MM/YYYY') : '',
    creationTime: order?.createdAt ? formatLocaleTime(order.createdAt) : '',
    totalAmount: order?.total || 0,
    status: order?.status?.name ?? ('' as EOrderStatus),
  })),
});

export const mapOrderDetail = (response: IGetOrderDetailResponse): IOrderDetail => ({
  orderInfo: {
    orderNumber: response.orderNumber,
    purchaseDate: formatDate(response.createdAt, 'DD/MM/YYYY'),
    purchaseTime: formatLocaleTime(response.createdAt || '', 'HH:mm A'),
    deviceName: response.deviceName,
  },
  deliveryInfo: {
    address: response.address,
    distributorName: response.distributor.name,
    status: response.status.name,
    statusDescription: response.status.description,
  },
  customer: {
    clientCode: response.customer.externalId,
    documentType: response.customer.documentType,
    documentNumber: response.customer.documentNumber,
    name: response.customer.name,
    email: response.customer.email,
    phone: response.customer.phone,
  },
  products: response.items.map(item => ({
    id: item.id,
    quantity: item.quantity,
    name: item.product.name,
    imageUrl: item.product.imageUrl,
    hasDiscount: item.hasDiscount,
    subtotal: item.totals.subtotal,
    totalAmount: item.totals.final,
    promotions: item.promotions.map(promo => ({
      id: promo.id,
      description: promo.description,
      totalAmount: promo.discount,
    })),
  })),
  currencySymbol: DEFAULT_CURRENCY.symbol,
  totals: {
    subtotal: response.totals.subtotal,
    perception: response.totals.perception,
    discount: response.totals.discount,
    total: response.totals.final,
  },
});
